const finite = (...values) => values.every(Number.isFinite);
const finiteResult = result => Object.values(result).every(Number.isFinite) ? result : null;

export function mortgageEstimate({ price, deposit, annualRate, years }) {
  if (!finite(price, deposit, annualRate, years) || price <= 0 || deposit < 0 || deposit > price || annualRate < 0 || annualRate > 100 || years < 1 || years > 50) return null;
  const principal = price - deposit;
  const months = Math.round(years * 12);
  const rate = annualRate / 1200;
  const payment = rate === 0 ? principal / months : principal * rate / (1 - (1 + rate) ** -months);
  return finiteResult({ principal, months, payment, totalInterest: Math.max(0, payment * months - principal), totalRepayment: payment * months });
}

export function affordabilityEstimate({ income, debts, debtRatio, deposit, annualRate, years }) {
  if (!finite(income, debts, debtRatio, deposit, annualRate, years) || income <= 0 || debts < 0 || debtRatio <= 0 || debtRatio > 100 || deposit < 0 || annualRate < 0 || annualRate > 100 || years < 1 || years > 50) return null;
  const payment = Math.max(0, income * debtRatio / 100 - debts);
  const months = Math.round(years * 12);
  const rate = annualRate / 1200;
  const principal = rate === 0 ? payment * months : payment * (1 - (1 + rate) ** -months) / rate;
  return finiteResult({ payment, principal, price: principal + deposit });
}

export function rentalYieldEstimate({ price, rent, annualCosts, vacancyRate }) {
  if (!finite(price, rent, annualCosts, vacancyRate) || price <= 0 || rent < 0 || annualCosts < 0 || vacancyRate < 0 || vacancyRate > 100) return null;
  const grossIncome = rent * 12;
  const netIncome = grossIncome * (1 - vacancyRate / 100) - annualCosts;
  return finiteResult({ grossIncome, netIncome, grossYield: grossIncome / price * 100, netYield: netIncome / price * 100 });
}
